import React from 'react';
import { useParams } from 'react-router-dom';
import PowerPerformanceBreadCrumb from './PowerPerformBreadCrumb';
import PowerPerformanceData from './PowerPerformanceData';

function PerformDataPage() {
    const { id, plantName } = useParams(); // Get dynamic route param

    return (
        <div className="container-fluid">
            <PowerPerformanceBreadCrumb />
            <PowerPerformanceData id={id} plantName={plantName} /> {/* Pass ID to child */}
        </div>
    );
}

export default PerformDataPage;
